let promise;

export default function ($http) {
    if (!promise) {
        promise = $http.get('api/codes/fileimporttypes');
    }

    return promise
    .then(result => {
        const {data: types} = result;
        return types;
    });
}



// WEBPACK FOOTER //
// ./Client/app/common/services/fileImportTypes.js